var React = require('react');

function Hourglass (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23 3c0 5.006-1.994 10.351-6.074 13C20.988 18.637 23 23.965 23 29h.25a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75H.75a.75.75 0 0 1-.75-.75v-1.5A.75.75 0 0 1 .75 29H1c0-5.006 1.994-10.351 6.074-13C3.012 13.363 1 8.035 1 3H.75A.75.75 0 0 1 0 2.25V.75A.75.75 0 0 1 .75 0h22.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75H23zM4 3c0 6.351 3.582 11.5 8 11.5S20 9.351 20 3H4zm16 26c0-6.351-3.582-11.5-8-11.5S4 22.649 4 29h16z"}));
}

Hourglass.defaultProps = {"viewBox":"0 0 24 32"};

module.exports = Hourglass;

Hourglass.default = Hourglass;
